import { MAX_GRID_WIDTH } from "config/styleConsts";
import PropTypes from "prop-types";
import { ChakraBox as Box, ChakraSimpleGrid as SimpleGrid } from "@airhelp/react-ui-components";

const Grid = ({ children, ...props }) => (
  <Box
    w="full"
    maxW={MAX_GRID_WIDTH}
    px={{ base: 4, lg: 4, xl: "unset" }}
    mb={{ base: 16, md: 32 }}
    mx="auto"
    {...props}
  >
    <SimpleGrid columns={{ base: 1, md: 12 }} spacing={8}>
      {children}
    </SimpleGrid>
  </Box>
);

export default Grid;

Grid.propTypes = {
  children: PropTypes.node,
};

Grid.defaultProps = {
  children: null,
};
